<template>
  <div>
    <ManageForm11 />
  </div>
</template>
<script>
import ManageForm11 from "@/components/ManageForm11/ManageForm11";
export default {
  components: {
    ManageForm11,
  },
  created() { this.year = JSON.parse(
        Decode.decode(localStorage.getItem("yearSelected"))
      );
  },
};
</script>